import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalFiles: 0,
  loading: false,
};

const documentCountSlice = createSlice({
  name: "documentCount",
  initialState,
  reducers: {
    setTotalFiles: (state, action) => {
      state.totalFiles = action.payload;
    },
    setDocumentCountLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setTotalFiles, setDocumentCountLoading } = documentCountSlice.actions;

export default documentCountSlice.reducer;
